import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Table, Card, Avatar, Button, Link, Pagination, Spin } from 'components/elements';
import Axios from 'axios';
import { BASE_URL, PAGE_SIZE } from '../../../inc/constants';
import { getAPIDefaultHeaders, handleCatch, handleEntityDelete } from '../../../inc/functions';

const HistoryList = ({ className }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  const [page, setPage] = useState(1);
  const columns = [
    {
      title: 'آیکون',
      dataIndex: 'icon',
      render: img => img && <Avatar src={img.thumbnail} />,
    },
    {
      title: 'تصویر',
      dataIndex: 'image',
      render: img => img && <Avatar src={img.thumbnail} />,
    },
    {
      title: 'عنوان',
      dataIndex: 'title',
    },
    {
      title: '',
      dataIndex: 'id',
      render: id => (
        <>
          <Link to={`/histories/${id}/edit/`}>
            <Button small secondary>ویرایش</Button>
          </Link>
          <Button onClick={() => handleEntityDelete('histories', id, 'تاریخچه', setLoading, load)} small error>حذف</Button>
        </>
      ),
    },
    
  ];
  useEffect(() => {
    load();
  }, [page]);

  const load = () => {
    setLoading(true);
    Axios.get(`${BASE_URL}/admin/histories/?page=${page}`, getAPIDefaultHeaders()).then((res) => {
      setData(res.data);
      setLoading(false);
    }).catch((err) => {
      handleCatch(err);
      setLoading(false);
    });
  };

  const cardMeta = (
    <div style={{textAlign: 'left'}}>
      <Link to="/histories/new/">
        <Button small>تاریخچه جدید</Button>
      </Link>
    </div>
  );

  return (
    <Card title="تاریخچه‌" meta={cardMeta}>
      <Spin active={loading}>
        <Table dataSource={data?.results || []} columns={columns} />
        <Pagination count={data?.count || 0} current={page} onChange={setPage}/>
      </Spin>
    </Card>
  );
};

export default HistoryList;
